'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { cn } from '../../../shared/cn';
export type DescriptionDetailsProps = React.ComponentPropsWithoutRef<'dd'>;
export function DescriptionDetails(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("border-borderSecondary py-2.5 text-contentPrimary text-sm leading-5 sm:border-t sm:nth-2:border-none", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <dd {...props} className={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}